import React from "react";
import "./MdmCard.css";
import moreMenu from "../../assets/image/svg/moreMenu.svg";
import RenderSvg from "../renderSvg/RenderSvg";
import { mdmCard } from "./types";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
function MdmCard(props: mdmCard) {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Master Data Management"
  const CUR_COMPONENT_COMMON="commonPortal";
  const colorPaletteForIcon = ["227C9D", "00C6B1", "FE6D73", "FFC220"];
  return (
    <>
      <div className="mdm-card-body">
        <div className="mdm-card-container">
          <div className="mdm-card-header">
            <div className="mdm-card-title">
              <div className="mdm-card-name">{translate(TranslationEnum.master_data_management,props?.mdmData?.name)}</div>
              <div
                className="mdm-card-icon"
                style={{ backgroundColor: "#" + colorPaletteForIcon[props.colorIndex % colorPaletteForIcon.length] }}
              >
                <RenderSvg className="mdm-card-svg" name={props.mdmData.id} />
              </div>
            </div>
          </div>
          <div className="mdm-card-footer">
              <div className="mdm-card-link">
              {props.mdmData.templateUrl ? translate(TranslationEnum.common_portal,"Download")  : ""}
                <a href={props.mdmData.templateUrl}>
                  <span className="mdm-card-template-link">
                    {props.mdmData.templateUrl ? ` ${translate(TranslationEnum.master_data_management,props?.mdmData?.name)}  ${translate(TranslationEnum.master_data_management,"Template")}` : ""}
                  </span>
                </a>
              </div>
            <div className="mdm-card-more-icon">
              <button
                id={props.mdmData.id}
                className="more-option-button"
                aria-describedby="simple-popper"
                type="button"
                onClick={props.changePopoverAnchorElement}
              >
                <img src={moreMenu} alt="moreMenu" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default MdmCard;
